import * as React from 'react';
import Link from 'next/link';
import { Label } from 'components/src/typography';
import Close from 'components/src/svg/Close';
import { colors } from 'components/src/foundation';

const PreviewBanner = () => {
  return (
    <div className={'fixed z-20 flex w-screen justify-center'}>
      <div className="flex h-32 w-fit items-center justify-center rounded-b-6 bg-red-100 px-16">
        <Label classes="flex h-24 items-center text-white-100">{'You are in Preview mode'}</Label>
        <Link prefetch={false} href="/api/disable-draft">
          <Close color={colors.primary.white} />
        </Link>
      </div>
    </div>
  );
};
export default PreviewBanner;
